export default {
    id: "58ab9ed8-94e7-4b79-a96f-879657b0198b",
    icon: "mdi-code-braces",
    name: "shapeBrace",
    title: "Shape Brace",
    description: "A block brace",
}